import React, { useEffect, useRef, useState } from 'react'
import PropTypes from "prop-types";
import AjouterOffre from '../../../components/AjouterOffre'
import { frenchDate } from '../../../../../variables/functions';
import { Button, Card, Divider, Dropdown, Modal, Space, Tag, Tooltip } from 'antd';
import { CalendarOutlined, CheckCircleOutlined, CreditCardOutlined, DownloadOutlined, EditOutlined, ExclamationCircleFilled, FileOutlined, PlusOutlined, PrinterOutlined, UserOutlined } from '@ant-design/icons';
import axiosInstance from '../../../../../variables/api/axiosInstance';
import PresentationOffre from '../../../docs/PresentationOffre';
import CourrierDeTransaction from '../../../docs/CourrierDeTransaction';
import { toast } from 'react-toastify';
import { displayNumbers } from '../../../../../variables/numbersFunctions';
import PresentationOffreAyantsDroit from '../../../docs/PresentationOffreAyantsDroit';
import { useReactToPrint } from 'react-to-print';
import { exportTableauAD } from './exports/tableauIndeminisationAyantDroits';
import ChoixBeneficiaireChequeModal from '../../../components/modals/ChoixBeneficiaireChequeModal';
import { getParametre } from '../../../../../hooks/useHooks';
import { PARAMETERS } from '../../../../../variables/constants';
const { confirm } = Modal;

const OffresSection = (props) => {
    // Offre en cours de transformation en règlement (ouvre le choix du bénéficiaire du chèque)
    const [offreARegler, setOffreARegler] = useState(null);
    const [decaissementLoading, setDecaissementLoading] = useState(false);
    const [motifOptions, setMotifOptions] = useState([]); // motifs MOTIF_REGLEMENT (Select transformation)
    const [isOffreModalVisible, setIsOffreModalVisible] = useState(false);
    const [offres, setOffres] = useState(props.offres);
    const [offre, setOffre] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [sinistre, setSinistre] = useState(props.sinistre);
    const [expertises, setExpertises] = useState(props.expertises);
    const [modalOffrePresentationVisible, setModalOffrePresentationVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [expertise, setExpertise] = useState({});
    const [exportLoading, setExportLoading] = useState(false);
    // Reste disponible = SAP − paiements en attente (validation ou chèque) : grise
    // « Initialiser le règlement » quand le total de l'offre dépasse.
    const [resteDisponible, setResteDisponible] = useState(null);

    useEffect(() => {
        if (!props?.sinistre?.codeId) return;
        axiosInstance.get(`/api/decaissement/reste-sap/${props.sinistre.codeId}`)
            .then((res) => setResteDisponible(Number(res.data?.resteDisponible)))
            .catch(() => setResteDisponible(null));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.sinistre?.codeId]);

    const printRef = useRef(null);
    const printCourrierRef = useRef(null);
    const printADRef = useRef(null);

    const handlePrintOffreIndemnisation = useReactToPrint({
        content: () => printRef.current,
        pageStyle: `
            @page {
                size: A4 portrait !important;
                margin: 20mm;
            }
            @media print {
                html, body {
                    width: 210mm;
                    height: 297mm;
                }
                body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
            }
        `,
        documentTitle: 'Offre indemnisation'
    });

    const handlePrintCourrierOffre = useReactToPrint({
        content: () => printCourrierRef.current,
        pageStyle: `
            @page {
                size: A4 portrait !important;
                margin: 20mm;
            }
            @media print {
                html, body {
                    width: 210mm;
                    height: 297mm;
                }
                body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
            }
        `,
        documentTitle: 'Attestation Declaration'
    });

    const handlePrintOffreAD = useReactToPrint({
        content: () => printADRef.current,
        pageStyle: `
            @page {
                size: A4 portrait !important;
                margin: 15mm;
            }
            @media print {
                * {
                    box-sizing: border-box;
                }
                html, body {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100% !important;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .ad-print-wrapper,
                .ad-print-wrapper * {
                    overflow: visible !important;
                    float: none !important;
                }
                .ad-print-wrapper {
                    display: block !important;
                    width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    height: auto !important;
                }
                .ad-page-block {
                    display: block !important;
                    width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    height: auto !important;
                    page-break-after: always !important;
                    break-after: page !important;
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                }
                .ad-page-block:last-child {
                    page-break-after: auto !important;
                    break-after: auto !important;
                }
                .ad-page-content {
                    width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                }
                .ad-page-content .header-image {
                    max-width: 100%;
                    height: auto;
                }
                .ad-page-content h4 {
                    margin: 8px 0 !important;
                    font-size: 14px !important;
                }
                .ad-page-content h6 {
                    margin: 4px 0 !important;
                    font-size: 12px !important;
                }
                .ad-page-content .info-section {
                    margin-bottom: 6px !important;
                }
                .ad-page-content .info-line {
                    margin-bottom: 1px !important;
                    font-size: 11px !important;
                    line-height: 1.4 !important;
                }
                .ad-page-content .table-container {
                    margin-bottom: 6px !important;
                }
                .ad-page-content .table {
                    font-size: 10px !important;
                    margin-bottom: 4px !important;
                }
                .ad-page-content .table th,
                .ad-page-content .table td {
                    padding: 3px 5px !important;
                }
                .ad-page-content .signature-section {
                    margin-top: 15px !important;
                }
                .ad-page-content .signature-section p {
                    margin: 4px 0 !important;
                    font-size: 11px !important;
                }
            }
        `,
        documentTitle: 'Offre ayants droit'
    });

    const downloadDocument = async (format, offreId) => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `/api/offre-indemnisation/${offreId}/download/${format}`,
                {
                    responseType: 'blob',
                }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const extension = format === 'word' ? 'docx' : 'pdf';
            link.setAttribute('download', `PV_Transaction_${sinistre?.numSinistre || sinistre?.numeroSinistreM}.${extension}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erreur lors du téléchargement:', error);
            alert('Erreur lors du téléchargement du document');
        } finally {
            setLoading(false);
        }
    };

    const handleExportTableauAD = async (item, format) => {
        setExportLoading(true);
        try {
            await exportTableauAD(item, sinistre, format);
        } catch (err) {
            console.error("Erreur export tableau AD :", err);
            toast.error("Erreur lors de la génération du fichier.");
        } finally {
            setExportLoading(false);
        }
    };

    const editOffre = (item) => {
        setOffre(item);
        setEditMode(true);
        setIsOffreModalVisible(true);
    };

    useEffect(() => {
        setSinistre(props.sinistre);
    }, [props.sinistre]);

    useEffect(() => {
        setExpertises(props.expertises);
    }, [props.expertises]);

    useEffect(() => {
        axiosInstance.get(`/api/offre-indemnisation/sinistre/${props.sinistre.codeId}`).then((response) => {
            // console.log(response.data);
            setOffres(response.data);
        }).catch((error) => {
            console.error("Error fetching notifications:", error);
        });
    }, []);

    // Dossier transfrontalier (carte brune) : pré-charger le BNCB pour le proposer par défaut au règlement.
    const [bncb, setBncb] = useState(null);
    useEffect(() => {
        if (!props.sinistre?.carteBrune) return;
        axiosInstance.get(`/api/etablissement/bncb`)
            .then((res) => setBncb(res.data || null))
            .catch(() => setBncb(null));
    }, [props.sinistre?.carteBrune]);

    // Motifs de règlement existants (MOTIF_REGLEMENT) pour le Select de la transformation.
    useEffect(() => {
        getParametre(PARAMETERS.motifReglement)
            .then(({ data }) => setMotifOptions((data || []).map((m) => ({ label: m.valeur, value: m.valeur }))))
            .catch(() => setMotifOptions([]));
    }, []);

    // Ouvre le choix « à l'ordre de qui » (victime ou représentant) avant de
    // transformer l'offre en règlement.
    const initDecaissement = (of) => {
        setOffreARegler(of);
    };

    // representantName : nom du représentant (chaîne) ou null = à l'ordre de la victime.
    // isAyantDroit : true si ce représentant est un ayant droit (préfixe « AD » sur le document).
    const confirmDecaissementOffre = (representantName, isAyantDroit, beneficiaireMoralCodeId, motif) => {
        if (!offreARegler) return;
        const mot = (motif || "").trim();
        if (!mot) { toast("Veuillez préciser le motif du règlement."); return; }
        setDecaissementLoading(true);
        const params = { motif: mot };   // motif du règlement — OBLIGATOIRE
        if (representantName) {
            params.representant = representantName;
            params.representantAyantDroit = !!isAyantDroit;
        }
        // Bénéficiaire moral (ex. BNCB) — dossier transfrontalier carte brune.
        if (beneficiaireMoralCodeId) params.beneficiaireMoralCodeId = beneficiaireMoralCodeId;
        axiosInstance
            .post(`/api/decaissement/init/offre/${offreARegler.codeId}/${sinistre.codeId}`, null, {
                params,
            })
            .then(() => {
                toast("Décaissement initialisé avec succès!");
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                toast(err?.response?.data?.message || "Erreur lors de l'initialisation");
            })
            .finally(() => setDecaissementLoading(false));
    };

    return (
        <div style={{ padding: "24px", backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
            {/* Header Section */}
            <div style={{
                marginBottom: "24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px"
            }}>
                <div>
                    <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 600, color: "#1a1a1a" }}>
                        <FileOutlined style={{ marginRight: "12px", color: "#4f46e5" }} />
                        Offres d'Indemnisation
                    </h2>
                    <p style={{ margin: "4px 0 0 0", color: "#6b7280", fontSize: "14px" }}>
                        {offres?.length || 0} offre(s) enregistrée(s)
                    </p>
                </div>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    size="large"
                    onClick={() => setIsOffreModalVisible(true)}
                    disabled={props?.sinistre?.sortDossier === "S" || props?.sinistre?.sortDossier === "T"}
                    style={{
                        backgroundColor: '#242166',
                        borderColor: '#242166',
                        height: "40px",
                        borderRadius: "8px",
                        fontWeight: 500,
                        boxShadow: "0 2px 8px rgba(79, 70, 229, 0.3)"
                    }}
                >
                    Nouvelle Offre
                </Button>
            </div>

            {/* Offres Grid */}
            {offres?.length ? (
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(450px, 1fr))",
                    gap: "20px"
                }}>
                    {offres.map((item, index) => (
                        <Card
                            key={item.codeId}
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #e5e7eb",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                                overflow: "hidden",
                                transition: "all 0.3s ease",
                                position: "relative"
                            }}
                            hoverable
                        >
                            {/* Badge Offre */}
                            <div style={{
                                position: "absolute",
                                top: "16px",
                                right: "16px",
                                backgroundColor: '#242166',
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: 600,
                                zIndex: 10
                            }}>
                                Offre N° {index + 1}
                            </div>

                            {/* Status Badge */}
                            {item?.decaissement && (
                                <div style={{
                                    position: "absolute",
                                    top: "16px",
                                    left: "16px",
                                    zIndex: 10
                                }}>
                                    <Tag
                                        icon={<CheckCircleOutlined />}
                                        color="success"
                                        style={{
                                            padding: "4px 10px",
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            border: "none"
                                        }}
                                    >
                                        Décaissement
                                    </Tag>
                                </div>
                            )}

                            <div style={{ paddingTop: item?.decaissement ? "40px" : "0" }}>
                                {/* Victim Info */}
                                <div style={{
                                    padding: "16px",
                                    backgroundColor: "#f9fafb",
                                    borderBottom: "1px solid #e5e7eb",
                                    borderRadius: "8px 8px 0 0"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        marginBottom: "12px"
                                    }}>
                                        <div style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            backgroundColor: '#242166',
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "white",
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }}>
                                            <UserOutlined />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 600, color: "#1a1a1a", fontSize: "14px" }}>
                                                {item?.victime?.personne?.prenom ? `${item?.victime?.personne?.nom} ${item?.victime?.personne?.prenom}` : item?.victime?.personne?.nom}
                                            </div>
                                            <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                                N° Offre: {item?.numeroOffre || "-"}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Details Section */}
                                <div style={{ padding: "16px" }}>
                                    {/* Nature */}
                                    <div style={{ marginBottom: "16px" }}>
                                        <div style={{
                                            fontSize: "12px",
                                            color: "#6b7280",
                                            fontWeight: 500,
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                            marginBottom: "6px"
                                        }}>
                                            Nature de l'offre
                                        </div>
                                        <Tag
                                            color={item.victime?.blesseSinistre ? "blue" : "red"}
                                            style={{
                                                padding: "6px 12px",
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                border: "none",
                                                borderRadius: "6px"
                                            }}
                                        >
                                            {item.victime?.blesseSinistre ? "👤 Victime blessée" : "⚰️ Victime décédée"}
                                        </Tag>
                                    </div>

                                    {/* Amount */}
                                    <div style={{
                                        padding: "12px",
                                        backgroundColor: "#f0fdf4",
                                        borderRadius: "8px",
                                        marginBottom: "16px",
                                        border: "1px solid #bbf7d0"
                                    }}>
                                        <div style={{
                                            fontSize: "12px",
                                            color: "#166534",
                                            fontWeight: 500,
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                            marginBottom: "4px"
                                        }}>
                                            Montant Total
                                        </div>
                                        <div style={{
                                            fontSize: "22px",
                                            fontWeight: 700,
                                            color: "#16a34a"
                                        }}>
                                            {item?.totalAPayer ? displayNumbers(item.totalAPayer) : "-"}
                                            <span style={{ fontSize: "13px", fontWeight: 500, marginLeft: "4px" }}>FCFA</span>
                                        </div>
                                    </div>

                                    {/* Date */}
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        fontSize: "13px",
                                        color: "#6b7280",
                                        marginBottom: "16px"
                                    }}>
                                        <CalendarOutlined style={{ color: "#4f46e5" }} />
                                        {frenchDate(item?.createdAt)}
                                    </div>

                                    <Divider style={{ margin: "16px 0" }} />

                                    {/* Actions */}
                                    <Space style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={() => editOffre(item)}
                                            block
                                            style={{
                                                backgroundColor: '#242166',
                                                borderColor: '#242166',
                                                borderRadius: "6px",
                                                fontWeight: 500
                                            }}
                                        >
                                            Éditer l'offre
                                        </Button>

                                        {!item?.decaissement && (() => {
                                            const depasse = resteDisponible != null
                                                && Number(item?.totalAPayer || 0) > resteDisponible + 0.01;
                                            return (
                                                <Tooltip title={depasse
                                                    ? `Montant de l'offre (${displayNumbers(item?.totalAPayer || 0)} F) supérieur au disponible : ${displayNumbers(resteDisponible)} F (SAP − paiements en attente)`
                                                    : ""}>
                                                    <Button
                                                        danger
                                                        icon={<CreditCardOutlined />}
                                                        onClick={() => initDecaissement(item)}
                                                        disabled={depasse}
                                                        block
                                                        style={{
                                                            borderRadius: "6px",
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        {depasse ? "Disponible SAP insuffisant" : "Initialiser le règlement"}
                                                    </Button>
                                                </Tooltip>
                                            );
                                        })()}

                                        <Button
                                            icon={<FileOutlined />}
                                            onClick={() => {
                                                console.log("item offre ", item);
                                                setOffre(item);
                                                setModalOffrePresentationVisible(true);
                                                let exp = expertises.find(e => e?.beneficiaire?.codeId === item?.victime?.codeId);
                                                setExpertise(exp);
                                            }}
                                            block
                                            style={{
                                                borderRadius: "6px",
                                                fontWeight: 500
                                            }}
                                        >
                                            Présentation de l'offre
                                        </Button>
                                        <Button
                                            icon={<FileOutlined />}
                                            onClick={() => {
                                                console.log("item offre ", item);
                                                setOffre(item);
                                                downloadDocument('word', item?.codeId);
                                            }}
                                            block
                                            style={{
                                                borderRadius: "6px",
                                                fontWeight: 500
                                            }}
                                            loading={loading}
                                        >
                                            PV de transaction
                                        </Button>
                                        {item.victime?.decesSinistre && (
                                            <Dropdown
                                                trigger={['click']}
                                                menu={{
                                                    items: [
                                                        {
                                                            key: 'excel',
                                                            label: (
                                                                <span>
                                                                    <DownloadOutlined style={{ marginRight: 8, color: '#217346' }} />
                                                                    Télécharger en Excel (.xlsx)
                                                                </span>
                                                            ),
                                                            onClick: () => handleExportTableauAD(item, 'excel'),
                                                        },
                                                        {
                                                            key: 'pdf',
                                                            label: (
                                                                <span>
                                                                    <DownloadOutlined style={{ marginRight: 8, color: '#c0392b' }} />
                                                                    Télécharger en PDF — Paysage (.pdf)
                                                                </span>
                                                            ),
                                                            onClick: () => handleExportTableauAD(item, 'pdf'),
                                                        },
                                                    ],
                                                }}
                                            >
                                                <Button
                                                    icon={<DownloadOutlined />}
                                                    block
                                                    loading={exportLoading}
                                                    style={{ borderRadius: "6px", fontWeight: 500 }}
                                                >
                                                    Tableau Ayants Droit ↓
                                                </Button>
                                            </Dropdown>
                                        )}

                                    </Space>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            ) : (
                <Card
                    style={{
                        borderRadius: "12px",
                        border: "2px dashed #d1d5db",
                        textAlign: "center",
                        padding: "60px 20px",
                        background: "#ffffff"
                    }}
                >
                    <FileOutlined style={{ fontSize: "64px", color: "#d1d5db", marginBottom: "16px" }} />
                    <h3 style={{ fontSize: "18px", fontWeight: 600, color: "#4b5563", margin: "0 0 8px 0" }}>
                        Aucune offre enregistrée
                    </h3>
                    <p style={{ color: "#6b7280", margin: 0 }}>
                        Aucune offre d'indemnisation n'a encore été créée pour ce dossier sinistre
                    </p>
                </Card>
            )}

            <AjouterOffre
                open={isOffreModalVisible}
                offre={offre}
                expertises={expertises}
                setOpen={setIsOffreModalVisible}
                edit={editMode}
                sinistre={sinistre}
            />
            <Modal
                open={modalOffrePresentationVisible}
                title="Présentation de l'offre"
                onCancel={() => setModalOffrePresentationVisible(false)}
                footer={null}
                width={1000}
                zIndex={2000}
            >
                {offre?.victime?.blesseSinistre && <>
                    <PresentationOffre ref={printRef} offre={offre} expertise={expertise} sinistre={sinistre} />
                    <Button
                        onClick={handlePrintOffreIndemnisation}
                        type="primary"
                        style={{ background: "green" }}
                        icon={<PrinterOutlined />}
                    >
                        Imprimer
                        <br />
                        <br />
                        <br />
                    </Button>
                </>}

                {offre?.victime?.decesSinistre &&
                    <>
                        <Button
                            onClick={handlePrintOffreAD}
                            type="primary"
                            style={{ background: "purple" }}
                            icon={<PrinterOutlined />}
                        >
                            Imprimer
                            <br />
                            <br />
                            <br />
                        </Button>
                        <PresentationOffreAyantsDroit ref={printADRef} offre={offre} expertise={expertise} sinistre={sinistre} />
                    </>
                }
                <br />
                {offre?.victime?.blesseSinistre && <>
                    <CourrierDeTransaction ref={printCourrierRef} offre={offre} expertise={expertise} sinistre={sinistre} />
                    <Button
                        onClick={handlePrintCourrierOffre}
                        type="primary"
                        style={{ background: "green" }}
                        icon={<PrinterOutlined />}
                    >
                        Imprimer
                        <br />
                        <br />
                        <br />
                    </Button>
                </>}
            </Modal>

            {/* Choix du destinataire du chèque (victime / représentant) avant règlement */}
            <ChoixBeneficiaireChequeModal
                open={!!offreARegler}
                onClose={() => setOffreARegler(null)}
                victime={offreARegler?.victime}
                loading={decaissementLoading}
                title="Transformer l'offre en règlement"
                okText="Confirmer le règlement"
                onConfirm={confirmDecaissementOffre}
                carteBrune={!!sinistre?.carteBrune}
                bncb={bncb}
                motifOptions={motifOptions}
            />
        </div>
    )
}

OffresSection.propTypes = {
    sinistre: PropTypes.object,
    expertises: PropTypes.array,
};

export default OffresSection